import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setAlert } from '../../actions/alert';

const Inicio = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [folio, setFolio] = useState(null);

    const onChange = (e) => {
        setFolio(e.target.value);
    }

    const searchFolio = () => {
        if(!folio){
            dispatch(setAlert('El folio es incorrecto', 'danger'));
        }else{
            if(folio.length != 6){
                dispatch(setAlert('El folio es incorrecto', 'danger'));
            }else{
                navigate('/recibo/' + folio);
            }
        }
    }

    return (
        <main className="main">
            <section id="error-404" class="error-404 section mb-5">
                <div class="container mb-5" data-aos="fade-up" data-aos-delay="100">
                    <div class="error-wrapper">
                        <div class="row align-items-center">
                            <div class="col-lg-6" data-aos="fade-right" data-aos-delay="200">
                                <div class="error-illustration">
                                    <i class="bi bi-question"></i>
                                    <div class="circle circle-1"></div>
                                    <div class="circle circle-2"></div>
                                    <div class="circle circle-3"></div>
                                </div>
                            </div>
                            <div class="col-lg-6" data-aos="fade-left" data-aos-delay="300">
                                <div class="error-content">
                                    <img className="logo-404 my-3" src="/assets/images/isotipo-color.png" data-aos="fade-up" data-aos-delay="500" alt="" />
                                    <h2 class="error-title" data-aos="fade-up" data-aos-delay="600">Búsqueda por folio</h2>
                                    <p class="error-description" data-aos="fade-up" data-aos-delay="700">Ingresa el folio de 6 dígitos que se encuentra en tu ticket impreso, luego presiona en el botón <b>Buscar</b>.</p>

                                    <div className="col-md-11" data-aos="fade-up" data-aos-delay="800">
                                        <div className="input-group mb-3">
                                            <div className="form-floating">
                                                <input type="text" className="form-control" placeholder="Folio de ticket" id="folio" name="folio" value={folio || ''} onChange={e => onChange(e)}></input>
                                                <label htmlFor="folio">Folio de ticket</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="error-actions" data-aos="fade-up" data-aos-delay="900">
                                        <button type="button" className="btn-home" onClick={() => searchFolio()}>
                                            <i class="bi bi-search"></i> Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Inicio;